import React from 'react';
import ImageComponent from 'components/Image';
import styled from 'styled-components';
import Button from 'components/Button';
import { getPriceWithCurrency } from 'utils/library';

interface MenuDetailsProps {
  title: string;
  image: string;
  price: number;
  description: string;
  currency: string;
  onCancel: () => void;
}

const MenuDetails = ({ title, image, price, description, currency, onCancel }: MenuDetailsProps) => {
  return (
    <MenuDetailsWrap>
      {image && <ImageComponent src={image} />}
      <div className="menu-content-wrap">
        <h2>{title}</h2>
        <h6 className="price-text">{getPriceWithCurrency(price, { decimalPlaces: 2, currency })}</h6>
        <p>{description}</p>

        <Button type="default" className="red-outline" block shape="round" onClick={onCancel}>
          Cancel
        </Button>
      </div>
    </MenuDetailsWrap>
  );
};

export default MenuDetails;

const MenuDetailsWrap = styled.div`
  .menu-img {
    width: 100%;
    object-fit: contain;
    height: 350px;
  }

  .menu-content-wrap {
    padding: 10px;

    .price-text {
      color: var(--orange);
      font-weight: bold;
    }
  }

  .red-outline {
    border-color: var(--orange);
  }
`;
